/*
 * ATTENTION: The "eval" devtool has been used (maybe by default in mode: "development").
 * This devtool is neither made for production nor for readable output files.
 * It uses "eval()" calls to create a separate source file in the browser devtools.
 * If you are trying to read the output file, select a different devtool (https://webpack.js.org/configuration/devtool/)
 * or disable the default devtool with "devtool: false".
 * If you are looking for production-ready output files, see mode: "production" (https://webpack.js.org/configuration/mode/).
 */
/******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "./src/scripts/sections/opk-product.js":
/*!*********************************************!*\
  !*** ./src/scripts/sections/opk-product.js ***!
  \*********************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n/* harmony import */ var _styles_sections_opk_product_scss__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../styles/sections/opk-product.scss */ \"./src/styles/sections/opk-product.scss\");\n\nconst items = [...document.querySelectorAll('[data-opk-upsell-product-price]')];\nconst assignUpsellCounter = () => {\n  const total = document.querySelector('[data-opk-upsell-total]');\n  items.forEach(item => {\n    item.addEventListener('change', () => {\n      const sum = items.reduce((acc, {\n        dataset,\n        checked\n      }) => checked ? acc + +dataset.opkUpsellProductPrice : acc, 0);\n      const sumFormated = (sum / 100).toFixed(2);\n      const sumSeparatedWithComa = sumFormated.replace('.', ',');\n      const proceFormatExample = total.getAttribute('data-opk-upsell-total');\n      const [currency, remaining] = proceFormatExample.split('{{');\n      const [priceFormat, suffix] = remaining.split('}}');\n      total.innerHTML = currency + (priceFormat === 'amount_with_comma_separator' ? sumSeparatedWithComa : sumFormated) + suffix;\n    });\n  });\n};\nconst assignUpsellAddButton = () => {\n  const button = document.querySelector('[data-opk-button-upsell]');\n  const buttonParts = [...button.querySelectorAll('[data-opk-button-upsell-content]')];\n  const errorContainer = document.querySelector('[data-opk-button-upsell-error]');\n  const toggleLoading = () => {\n    buttonParts.forEach(({\n      classList\n    }) => {\n      classList.toggle('active');\n    });\n  };\n  button.addEventListener('click', async () => {\n    toggleLoading();\n    const checkedItems = items.filter(({\n      checked\n    }) => checked);\n    if (!checkedItems.length) {\n      toggleLoading();\n      return;\n    }\n    ;\n    const payload = checkedItems.map(({\n      value\n    }) => ({\n      'id': value,\n      'quantity': 1\n    }));\n    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {\n      method: 'POST',\n      headers: {\n        'Content-Type': 'application/json'\n      },\n      body: JSON.stringify({\n        items: [...payload]\n      })\n    });\n    toggleLoading();\n    if (res.ok) {\n      window.location.href = '/cart';\n      return;\n    }\n    const {\n      message\n    } = await res.json();\n    errorContainer.innerHTML = message;\n    errorContainer.classList.add('active');\n  });\n};\nassignUpsellCounter();\nassignUpsellAddButton();\n\n//# sourceURL=webpack://la-luna-bags/./src/scripts/sections/opk-product.js?");

/***/ }),

/***/ "./src/styles/sections/opk-product.scss":
/*!**********************************************!*\
  !*** ./src/styles/sections/opk-product.scss ***!
  \**********************************************/
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

eval("__webpack_require__.r(__webpack_exports__);\n// extracted by mini-css-extract-plugin\n\n\n//# sourceURL=webpack://la-luna-bags/./src/styles/sections/opk-product.scss?");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
/******/ 	
/******/ 	// startup
/******/ 	// Load entry module and return exports
/******/ 	// This entry module can't be inlined because the eval devtool is used.
/******/ 	var __webpack_exports__ = __webpack_require__("./src/scripts/sections/opk-product.js");
/******/ 	
/******/ })()
;